import script from "./PdfViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfViewer.vue?vue&type=script&setup=true&lang=js"

import "./PdfViewer.vue?vue&type=style&index=0&id=4feeed44&scoped=true&lang=scss"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4feeed44"]])

export default __exports__